import { Languages } from 'lucide-react';
import { useI18n, SUPPORTED_LOCALES } from '@solara/i18n';
import type { Locale } from '@solara/i18n';
import { Button } from './Button';

const LABELS: Record<Locale, { short: string; long: string }> = {
  'en-AE': { short: 'EN', long: 'English' },
  'ar-AE': { short: 'AR', long: 'العربية' },
  'hu-HU': { short: 'HU', long: 'Magyar' },
};

export function LanguageToggle() {
  const { locale, setLocale } = useI18n();
  return (
    <div className="inline-flex items-center gap-1 rounded-md border border-border bg-surface px-1 py-0.5">
      <Languages className="h-4 w-4 text-fg-muted mx-1" aria-hidden="true" />
      {SUPPORTED_LOCALES.map((l) => {
        const isActive = l === locale;
        return (
          <Button
            key={l}
            type="button"
            variant={isActive ? 'primary' : 'ghost'}
            size="sm"
            onClick={() => setLocale(l)}
            aria-pressed={isActive}
            aria-label={`Switch language to ${LABELS[l].long}`}
            title={LABELS[l].long}
            className={isActive ? 'h-7 px-2 font-semibold' : 'h-7 px-2 text-fg-muted'}
          >
            {LABELS[l].short}
          </Button>
        );
      })}
    </div>
  );
}
